/** Путь относительно `public/`, без ведущего слэша, например `images/hero.png` */
export const publicAssetUrl = (path: string) => {
  const base = import.meta.env.BASE_URL
  const normalized = path.replace(/^\/+/, "")
  return `${base}${normalized}`
}
